import { cacheKeys } from "@constants/cache-keys";
import { isScreenshotMode } from "@constants/common";
import { mockedLeaderboard } from "@constants/mocked-data";
import { useExamContext } from "@features/exam/contexts/ExamContext";
import useClerkUser from "@hooks/useClerkUser";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { type PeriodType, fetchLeaderboardItems } from "../api/queries";
import { filterChips } from "../components/Leaderboard/constants";

const useLeaderboard = () => {
	const [selectedChip, setSelectedChip] = useState(filterChips[0].type);

	const {
		currentExamContext: { projectId, organizationId },
	} = useExamContext();
	const { userPublicMetadataId } = useClerkUser();

	const { data: leaderboardResponse, isLoading: fetchingLeaderboard } =
		useQuery({
			queryKey: [cacheKeys.leaderboard, selectedChip],
			queryFn: () =>
				isScreenshotMode
					? mockedLeaderboard[selectedChip]
					: fetchLeaderboardItems({
							periodType: selectedChip,
							projectId,
							organizationId,
							userPublicMetadataId: userPublicMetadataId,
						}),
			enabled: !!projectId && !!organizationId && !!userPublicMetadataId,
		});

	const finalLeaderboards = leaderboardResponse;

	const leaderboardPodiumData = finalLeaderboards
		?.slice(0, 3)
		.map((item, index) => ({
			...item,
			rank: index + 1,
		}));

	const reorderedPodiumData = leaderboardPodiumData?.length
		? [
				leaderboardPodiumData[1],
				leaderboardPodiumData[0],
				leaderboardPodiumData[2],
			]
		: [];
	return {
		leaderboards: finalLeaderboards,
		fetchingLeaderboard,
		podiumData: reorderedPodiumData,
		selectedChip,
		handleSelectChip: (chip: PeriodType) => setSelectedChip(chip),
	};
};

export default useLeaderboard;
